import React from "react";
import { Database, Eye, Lock, Share2, Smartphone, Trash2 } from "lucide-react";
import LegalPageLayout from "../components/LegalPageLayout";

const SECTIONS = [
  { icon: Database, title: "What we collect", points: [
    "Account details: your name, email address and an encrypted password.",
    "What you create: prompts, chat messages, attached images, generated code, versions and published apps.",
    "Payments: order amounts and payment status from Razorpay. We never see or store your card, UPI or bank details.",
    "Basic usage data (pages visited, device and browser type) to keep the service working and improve it.",
  ] },
  { icon: Eye, title: "How we use it", points: [
    "To run your account, build and host your apps, and keep your credit balance correct.",
    "Your prompts and attachments are sent to our AI model providers only to generate your app. They are not used to advertise to you.",
    "To send important emails about your account, payments and custom domains.",
  ] },
  { icon: Share2, title: "Who we share it with", points: [
    "Service providers that help us run Ishukart: hosting and storage, AI model providers, Razorpay for payments and our custom-domain provider.",
    "We do not sell your personal data. We share data with authorities only when the law requires it.",
  ] },
  { icon: Smartphone, title: "Mobile apps", points: [
    "The Ishukart Android and iPhone apps show the same Ishukart website, so this policy covers them too.",
    "The apps only ask for camera, photos or microphone access when you choose to attach an image or use voice typing.",
  ] },
  { icon: Lock, title: "Security", points: [
    "All traffic is encrypted with HTTPS. Passwords are hashed and GitHub tokens are encrypted.",
    "Apps you publish are public at their address; private share links can be protected with a passcode.",
  ] },
  { icon: Trash2, title: "Your choices", points: [
    "You can download or delete your projects at any time from your dashboard.",
    "You can ask us to delete your whole account on the Data deletion page. Payment records required by Indian tax law are kept for the legally required period.",
  ] },
];

export default function Privacy() {
  return (
    <LegalPageLayout badge="Privacy" title="Privacy policy" subtitle="What Ishukart collects, why, and the choices you have." lastUpdated="June 2026" sections={SECTIONS}
      ctaTitle="Questions about your data?" ctaText="Write to support@ishukart.org or use the contact form — we usually reply within one business day." />
  );
}
